<div
	class="main-container w-100 d-flex align-items-center justify-content-center"
>
	<div class="container px-0 w-sm-100 w-50 row">
		<div class="ratings">
			<h4 class="w-auto text-center mb-0 px-3">{{ page.selfScores }}</h4>
			<div *ngFor="let score of data.scores">
				<div *ngIf="score.self" class="w-auto text-center mb-0 px-3">
					{{ getSkillName(score.uid) }}: {{ score.self.toFixed(1) }}
				</div>
			</div>
			<div *ngIf="noSelfScores" class="w-auto text-center mb-0 px-3">
				{{ page.noSelfScores }}
			</div>
		</div>
		<div class="ratings">
			<h4 class="w-auto text-center mb-0 px-3">{{ page.peerScores }}</h4>
			<div *ngFor="let score of data.scores">
				<div *ngIf="score.peer" class="w-auto text-center mb-0 px-3">
					{{ getSkillName(score.uid) }}: {{ score.peer.toFixed(1) }}
				</div>
			</div>
			<div *ngIf="noPeerScores" class="w-auto text-center mb-0 px-3">
				{{ page.noPeerScores }}
			</div>
		</div>
	</div>
</div>
<app-skill-builder-text-box
	[title]="page.insight"
	[value]="data.insight"
	[errorRequired]="page.errorRequired"
	[footer]="page.additionalQuestions"
	[next]="next"
></app-skill-builder-text-box>
